import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addEmperor from "./components/add.vue";
import { abnormalChatUserList, unbanUser, abnormalChatUserListAll } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
import { mapState, mapActions } from 'vuex';
export default {
  name: "chatAbnormalUser",
  mixins: [gmToolNew, gmToolNewPage],
  components: {
    addEmperor: addEmperor
  },
  data: function data() {
    return {
      advanced: false,
      tableData: [],
      paramsData: {
        uid: '',
        start_time: '',
        end_time: '',
        page: 1
      },
      date: [],
      total: 0,
      exportdataDealoading: false,
      statusType: {
        0: this.$t('unban'),
        1: this.$t('mute'),
        2: this.$t('banAccount'),
        3: this.$t('pending')
      },
      popData: {
        server_id: ''
      }
    };
  },
  created: function created() {},
  computed: _objectSpread({}, mapState("d2admin", {
    rawData: function rawData(state) {
      return state.serchSelect.rawData;
    }
  })),
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this.paramsData.server_id.length == 0)) {
                  _context2.next = 3;
                  break;
                }

                _this.$message.error(_this.$t('pleaseSelectServer'));

                return _context2.abrupt("return");

              case 3:
                _this.paramsData.page = e;
                _this.paramsData.start_time = _this.date && _this.date[0] ? _this.$times.timestampToTime(_this.date[0] / 1000, "YY-MM-DD hh:mm:ss") : '';
                _this.paramsData.end_time = _this.date && _this.date[1] ? _this.$times.timestampToTime(_this.date[1] / 1000, "YY-MM-DD hh:mm:ss") : '';
                _this.reqLoading = true;
                abnormalChatUserList(_this.paramsData).then(function (res) {
                  if (res.code == 200) {
                    var date = Math.abs(new Date(_this.$times.zeroTimeZone()).getTime() / 1000);
                    _this.tableData = res.data.data;
                    _this.total = res.data.total;
                  }
                }).finally(function () {
                  _this.reqLoading = false;
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    punishItem: function punishItem(row) {
      row.uid = row.role_id;
      this.popData = row;
      this.$refs.addEmperor.open(row, true);
    },
    deleHandle: function deleHandle(row) {
      var _this2 = this;

      this.$confirm(this.$t('confirmUnbanOperation'), this.$t('prompt'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                unbanUser({
                  is_abnormal_op: true,
                  is_abnormal_chat: true,
                  uids: [row.role_id],
                  server_id: row.server_id,
                  env_id: _this2.paramsData.env_id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this2.getList(_this2.paramsData.page);

                    _this2.$message({
                      type: "success",
                      message: _this2.$t('operationSuccess')
                    });
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    },
    exportdata: function exportdata() {
      var _this3 = this;

      this.exportdataDealoading = true;
      this.paramsData.start_time = this.date && this.date[0] ? this.$times.timestampToTime(this.date[0] / 1000, "YY-MM-DD hh:mm:ss") : '';
      this.paramsData.end_time = this.date && this.date[1] ? this.$times.timestampToTime(this.date[1] / 1000, "YY-MM-DD hh:mm:ss") : '';
      var data = [];
      abnormalChatUserListAll(this.paramsData).then(function (res) {
        if (res.code == 200) {
          var date = Math.abs(new Date(_this3.$times.zeroTimeZone()).getTime() / 1000);
          data = res.data;
          var columns = [{
            label: _this3.$t('packageName'),
            prop: 'pkg'
          }, {
            label: _this3.$t('playerId'),
            prop: 'role_id'
          }, {
            label: _this3.$t('serverId'),
            prop: 'server_id'
          }, {
            label: _this3.$t('sentContent'),
            prop: 'content'
          }, {
            label: _this3.$t('sentCount'),
            prop: 'content_times'
          }, {
            label: _this3.$t('banReason'),
            prop: 'reason'
          }, {
            label: _this3.$t('executionTime'),
            prop: 'exc_time'
          }, {
            label: _this3.$t('messageSentTime'),
            prop: 'chat_time'
          }, {
            label: _this3.$t('banStatus'),
            prop: 'op_type'
          }, {
            label: _this3.$t('banExpireTime'),
            prop: 'expire_time'
          }];
          data.map(function (i) {
            i.op_type = _this3.statusType[i.op_type];
          });

          _this3.$export.excel({
            columns: columns,
            data: data,
            title: _this3.$route.meta.title
          });
        }
      }).finally(function () {
        _this3.exportdataDealoading = false;
      });
    },
    goToUserDetail: function goToUserDetail(id) {
      this.$router.replace({
        name: 'playerDetails_yujian',
        params: {
          id: id,
          env_id: this.paramsData.env_id,
          server_channel: this.server_channel,
          show_test: this.show_test,
          server_id: this.paramsData.server_id
        }
      });
    }
  }
};